import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import {ModalDismissReasons, NgbDate, NgbDateStruct, NgbModal, NgbTypeahead, NgbTypeaheadSelectItemEvent} from '@ng-bootstrap/ng-bootstrap';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { debounceTime, distinctUntilChanged, filter, firstValueFrom, from, map, merge, Observable, of, OperatorFunction, Subject } from 'rxjs';
import { Funzionalita } from 'src/app/model/Funzionalita';
import {
  Contatto,
  DettaglioAnagrafica,
  Diagnosi,
  DiagnosiEScale,
  DiagnosiEscaleAudit, DiagnosiIcd10,
  NotAvailableDatesContainer,
  Presenza,
  Utente
} from 'src/app/model/Models';
import { ApiService } from 'src/app/services/api.service';
import { SessionService } from 'src/app/services/session.service';
import { ToastService } from 'src/app/services/toast.service';
import {
  dataNonValidaValidator,
  emptyDiagnosiValidator,
  optionalDiagnosiValidator,
  scalaBprsValidator,
  scalaHonosValidator
} from 'src/app/util/codicefiscale.validators';
import {CommonsUtil} from "../../util/CommonsUtil";
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-diagnosi-scale',
  templateUrl: './diagnosi-scale.component.html',
  styleUrls: ['./diagnosi-scale.component.css']
})
export class DiagnosiScaleComponent implements OnInit {


  anagrafica!: DettaglioAnagrafica

  diagnosiScala!: DiagnosiEScale

  mainUser!: Utente

  contatto!: Contatto

  diagnosiScaleForm!: FormGroup

  minDate?: NgbDateStruct

  maxDate = { year: 2035, month: 1, day: 1 }

  dateModel!: NgbDateStruct

  closeResult = ''

  formSubmitted = false;

  listDiagnosi: Diagnosi[] = []

  listDiagnosiEScale:DiagnosiEScale[ ] = []

  listDate: string[] = []

  modelDiagnosi!: any
  enableStatiAttuali: Array<number> = [1,2,4,7,9,0];
  listDiagnosiIcd10: DiagnosiIcd10[] = [];
  modelDiagnosiIcd10!: DiagnosiIcd10 | string | null;
  suggestedDiagnosiIcd9: Diagnosi[] = []
  private lastIcd10SuggestionsCode: string | null = null;
  private lastDiagnosiIcd10CodeForReset: string | null = null;

  private readonly diagnosiIcd10VisibleFromDate = new Date(2026, 0, 1);
  private diagnosiIcd10RequiredFromDate = this.parseConfigDate(environment.diagnosiIcd10RequiredFromDate) ?? new Date(2026, 3, 1);


  // for diagnosi typeahead
  @ViewChild('instanceDiagnosiScala', { static: true }) instanceDiagnosiScala: NgbTypeahead | undefined;
  focus$ = new Subject<string>();
  click$ = new Subject<string>();

  private formatDiagnosiIcd9(diagnosi: Diagnosi | null | undefined): string {
    if (!diagnosi) return '';
    const codice = (diagnosi.codice ?? '').toString().trim();
    if (!codice) return '';
    const descr = ((diagnosi as any).descrizione ?? (diagnosi as any).descrizioneDiagnosi ?? '').toString().trim();
    return `${codice} - ${descr}`;
  }

  formatter = (diagnosi: Diagnosi) => this.formatDiagnosiIcd9(diagnosi)

  resultFormatter = (diagnosi: Diagnosi) => this.formatDiagnosiIcd9(diagnosi);

  diagnosiScaleSearch: OperatorFunction<string, readonly Diagnosi[]> = (textDiagnosi$: Observable<string>) => {
    const debouncedText$ = textDiagnosi$.pipe(debounceTime(200), distinctUntilChanged());
    const clicksWithClosedPopup$ = this.click$.pipe(filter(() => !this.instanceDiagnosiScala?.isPopupOpen()));
    const inputFocus$ = this.focus$;

    return merge(debouncedText$, inputFocus$, clicksWithClosedPopup$).pipe(
      map((term: string) => this.mergeDiagnosiIcd9Results(term))
    )
  }

  formatterIcd10 = (diagnosi: DiagnosiIcd10) => (diagnosi.codice != undefined ? diagnosi.codice!! + ' - ' + diagnosi.descrizione! : '')
  resultFormatterIcd10 = (diagnosi: DiagnosiIcd10) => (diagnosi.codice != undefined ? diagnosi.codice!! + ' - ' + diagnosi.descrizione! : '');

  diagnosiScaleSearchIcd10: OperatorFunction<string, readonly DiagnosiIcd10[]> = (textDiagnosi$: Observable<string>) =>
    textDiagnosi$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map((term: string) => term.length < 2 ? []
        : this.listDiagnosiIcd10
          .filter(dia =>
            dia && dia.descrizione && dia.descrizione.toLowerCase().indexOf(term.toLowerCase()) > -1
            || dia && dia.codice && dia.codice.toLowerCase().indexOf(term.toLowerCase()) > -1
          ) )
    )

  @BlockUI()
  blockUI!: NgBlockUI;


  constructor(private router: Router, private sessionService: SessionService,
    private modalService: NgbModal, private apiService: ApiService, private toastService: ToastService) {
    this.loadDiagnosiScaleForm();
  }

  async ngOnInit() {

    this.loadDiagnosiIcd10RequiredDate()
    this.loadUser()
    this.loadAnagrafica()
    this.loadContatto()
    this.loadDiagnosiIcd10List()
    this.loadNotAvailableDateList()
    this.loadDiagnosiEScala()

    this.observeStrutturaChange()
    this.limitMaxDate()

    this.diagnosiScaleForm.get('diagnosiScalaICD10')?.valueChanges.subscribe(() => this.refreshIcd9SuggestionsFromIcd10());
    this.diagnosiScaleForm.get('data')?.valueChanges.subscribe(() => {
      this.refreshDiagnosiIcd10Validators();
      if (!this.showDiagnosiIcd10()) {
        this.modelDiagnosiIcd10 = null;
        this.diagnosiScaleForm.get('diagnosiScalaICD10')?.setValue(null, { emitEvent: false });
      }
    });
  }

  loadUser() {
    this.mainUser = this.sessionService.getUtenteFromStorage()!!
  }
  disabledDates:NgbDateStruct[]=[]
  isDisabled=(date:NgbDateStruct,current: {month: number,year:number}|undefined)=> {
    //in current we have the month and the year actual
    return this.disabledDates.find(x=>new NgbDate(x.year,x.month,x.day).equals(date))?
      true:false;
  }
  loadDiagnosiEScala() {
    this.sessionService.selectedDiagnosiScale.subscribe(res => {
      this.diagnosiScala = JSON.parse(res);

      this.getAllDiagnosi().then(res => {

        this.listDiagnosi = res

        this.modelDiagnosi = this.getDiagnosiModel(this.contatto, this.diagnosiScala, this.listDiagnosi)
        this.diagnosiScaleForm.get('diagnosiScala')?.setValue(this.modelDiagnosi, { emitEvent: false })
        this.modelDiagnosiIcd10 = this.getDiagnosiIcd10Model(this.contatto, this.diagnosiScala)
        this.diagnosiScaleForm.get('diagnosiScalaICD10')?.setValue(this.modelDiagnosiIcd10, { emitEvent: false })
        this.lastDiagnosiIcd10CodeForReset = this.getDiagnosiIcd10Code(this.modelDiagnosiIcd10);
        this.refreshDiagnosiIcd10Validators();
        this.refreshIcd9SuggestionsFromIcd10();
        // seconda parte solo se si puo cambiare il dato di una diagnosi essistente
        if (!this.isFirstDiagnosiOfContatto(this.contatto.diagnosiEScaleList!!) && !this.isDiagnosiEScaleNotNew(this.diagnosiScala)) {
          this.limitDateByContattoDate(this.contatto)
        }

        //if(!this.isFirstDiagnosiOfContatto(this.contatto.diagnosiEScaleList!!)){
        //  this.limitDateByDiagnosiDate(this.contatto!!.diagnosiEScaleList!![this.contatto.diagnosiEScaleList!!.length -1]!!)
        //}

        // if(!this.isFirstDiagnosiOfContatto(this.contatto.diagnosiEScaleList!!)){

          // this.limitDateByDiagnosiDate(this.contatto!!.diagnosiEScaleList!![this.contatto.diagnosiEScaleList!!.length -1]!!)
          //this.limitDateByDiagnosiDate(this.diagnosiScala)

        // }


      })

      if (this.diagnosiScala.id != null || this.diagnosiScala.id != undefined) {
        this.setFormValues(this.diagnosiScala)
      } else {
        this.observeFormForDuplicateDates()
      }
      this.dateModel = this.loadDateModel(this.contatto)!!

    })
  }

  observeFormForDuplicateDates() {

    this.diagnosiScaleForm.get('data')?.valueChanges.subscribe(val => {

      this.dateExistInDates(val)
    })
  }



  loadContatto() {

    this.sessionService.selectedContatto.subscribe(res => {
      this.contatto = res
      this.refreshDiagnosiIcd10Validators();
      this.refreshIcd9SuggestionsFromIcd10();

    })
  }

  loadNotAvailableDateList() {


    this.sessionService.listDIagnosiEscaleDataNotAvailable.subscribe(res => {
      this.listDate = res
      this.disabledDates = [];
      for(let l of this.listDate){
        let c:NgbDateStruct = JSON.parse(l);
        this.disabledDates.push(c);
      }
    })

  }

  loadAnagrafica() {

    this.sessionService.selectedAnagrafica.subscribe(res => {
      this.anagrafica = JSON.parse(res)
    })
  }

  loadDateModel(contatto: Contatto): NgbDateStruct | null {

    let date: NgbDateStruct | null = null

    if (this.isFirstDiagnosiOfContatto(contatto.diagnosiEScaleList!!)) {
      date = this.sessionService.convertToDateStruct(new Date(contatto.dataApertura!!))!!
    } else if (this.diagnosiScala.id != undefined || this.diagnosiScala.id != null) {
      date = this.sessionService.convertToDateStruct(new Date(this.diagnosiScala.data!!))!!
    }



    return date;
  }

  navigateToRicercaAnagrafica() {
    this.router.navigate(['ricerca-anagrafica'])
  }

  navigateToAnagrafica() {
    this.router.navigate(['contatto'])
  }

  getTitleName(): string {
    if (this.anagrafica.nome === "") {
      return "Nuova Prestazione"
    } else {
      return "" + this.anagrafica.cognome + " " + this.anagrafica.nome + ' (CF: ' + this.anagrafica.codiceFiscale + ")"
    }
  }

  loadDiagnosiScaleForm() {

    this.diagnosiScaleForm = new FormGroup({
      data: new FormControl("", [Validators.required]),
      diagnosiScala: new FormControl("",[ emptyDiagnosiValidator()]),
      diagnosiScalaICD10: new FormControl(null,[ optionalDiagnosiValidator() ]),
      scalaHonos: new FormControl("", [scalaHonosValidator()]),
      scalaBprs: new FormControl("", [scalaBprsValidator()])
    })
  }

  private resolveDiagnosiIcd10Model(model: DiagnosiIcd10 | string | null | undefined): DiagnosiIcd10 | null {
    if (model == null) {
      return null;
    }

    if (typeof model === 'string') {
      const term = model.trim();
      if (!term) {
        return null;
      }
      const codice = term.split(' - ')[0].trim();
      const found = this.listDiagnosiIcd10?.find(d => d?.codice?.toLowerCase() === codice.toLowerCase());
      return found ?? null;
    }

    if (model.codice != null && model.codice.trim() !== '') {
      return model;
    }

    return null;
  }

  private getDiagnosiIcd10Code(model: DiagnosiIcd10 | string | null | undefined): string | null {
    const resolved = this.resolveDiagnosiIcd10Model(model);
    const code = resolved?.codice?.trim();
    return code ? code : null;
  }

  private resetIcd9IfIcd10Changed(currentIcd10Code: string | null): void {
    const hasIcd9Value = !!this.modelDiagnosi?.codice || !!this.diagnosiScaleForm.get('diagnosiScala')?.value;
    if (currentIcd10Code
      && hasIcd9Value
      && this.lastDiagnosiIcd10CodeForReset !== currentIcd10Code) {
      this.modelDiagnosi = null;
      this.diagnosiScaleForm.get('diagnosiScala')?.setValue(null, { emitEvent: false });
      this.diagnosiScaleForm.get('diagnosiScala')?.markAsDirty();
      this.diagnosiScaleForm.get('diagnosiScala')?.updateValueAndValidity({ onlySelf: true });
    }
    this.lastDiagnosiIcd10CodeForReset = currentIcd10Code;
  }

  onDiagnosiIcd10Selected(event: NgbTypeaheadSelectItemEvent): void {
    const diagnosi = event.item as DiagnosiIcd10;
    if (!diagnosi) return;

    const nextCode = this.getDiagnosiIcd10Code(diagnosi);
    this.modelDiagnosiIcd10 = diagnosi;
    this.diagnosiScaleForm.get('diagnosiScalaICD10')?.setValue(diagnosi, { emitEvent: false });
    this.diagnosiScaleForm.get('diagnosiScalaICD10')?.markAsDirty();
    this.diagnosiScaleForm.get('diagnosiScalaICD10')?.updateValueAndValidity({ onlySelf: true });

    this.resetIcd9IfIcd10Changed(nextCode);
    this.refreshIcd9SuggestionsFromIcd10();
  }

  private getDiagnosiReferenceDate(): Date | null {
    // Priorità: data selezionata nella scheda diagnosi&scale (creazione/modifica)
    const fromControl = this.sessionService.toNativeDate(this.diagnosiScaleForm?.get('data')?.value ?? null);
    if (fromControl) return fromControl;
    if (this.dateModel) {
      const fromModel = this.sessionService.toNativeDate(this.dateModel);
      if (fromModel) return fromModel;
    }
    // fallback: data già salvata sulla diagnosi&scale
    if (this.diagnosiScala?.data) {
      const d = new Date(this.diagnosiScala.data as any);
      if (!isNaN(d.getTime())) return d;
    }
    // ultimo fallback: data apertura contatto
    if (this.contatto?.dataApertura) {
      const d = new Date(this.contatto.dataApertura as any);
      if (!isNaN(d.getTime())) return d;
    }
    return null;
  }

  showDiagnosiIcd10(): boolean {
    // Mostra sempre se il dato esiste gia' (anche per operatore-regione o altri ruoli).
    if (this.contatto && (this.contatto.codiceDiagnosiAperturaIcd10 || this.contatto.codiceDiagnosiChiusuraIcd10)) {
      return true;
    }
    if (this.diagnosiScala && this.diagnosiScala.diagnosiIcd10) {
      return true;
    }
    const currentModel = this.diagnosiScaleForm?.get('diagnosiScalaICD10')?.value ?? this.modelDiagnosiIcd10;
    if (this.resolveDiagnosiIcd10Model(currentModel)) {
      return true;
    }

    // Per tutti: il campo e' visualizzabile in base alla data apertura contatto (dal 2026-01-01).
    if (!this.contatto || !this.contatto.dataApertura) return false;
    const apertura = new Date(this.contatto.dataApertura);
    if (isNaN(apertura.getTime())) return false;
    return this.isSameOrAfterDay(apertura, this.diagnosiIcd10VisibleFromDate);
  }

  private isDiagnosiIcd10Required(): boolean {
    if (!this.showDiagnosiIcd10()) return false;
    // CHANGE REQUEST PRE-RILASCIO:
    // l'unica ASL in sperimentazione per ICD10 e' 109 (Viterbo).
    // Se in futuro dovranno essere abilitate altre ASL, andranno cablate esplicitamente qui.
    if (!this.mainUser || this.mainUser.codiceAsl !== "109") return false;
    if (!this.contatto || !this.contatto.dataApertura) return false;
    const apertura = new Date(this.contatto.dataApertura);
    if (isNaN(apertura.getTime())) return false;
    return this.isSameOrAfterDay(apertura, this.diagnosiIcd10RequiredFromDate);
  }

  private isSameOrAfterDay(date: Date, threshold: Date): boolean {
    const d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    const t = new Date(threshold.getFullYear(), threshold.getMonth(), threshold.getDate());
    return d.getTime() >= t.getTime();
  }

  isDiagnosiIcd10RequiredLabel(): boolean {
    return this.isDiagnosiIcd10Required();
  }

  /**
   * //[CHANGE-REQUEST][PRE-RILASCIO]
   * Mostra la notina informativa su Diagnosi ICD10 solo ai profili con permesso di scrittura.
   * @lastUpdate 2026-03-11 - Alessio Scoppetta
   * @author Alessio Scoppetta
   */
  canShowDiagnosiIcd10Info(): boolean {
    return this.hasWritePermission(this.mainUser);
  }

  /**
   * //[CHANGE-REQUEST][PRE-RILASCIO]
   * Restituisce il testo informativo sulla data di obbligatorieta' della Diagnosi ICD10
   * leggendo la soglia configurata da property di sistema.
   * @lastUpdate 2026-03-11 - Alessio Scoppetta
   * @author Alessio Scoppetta
   */
  getDiagnosiIcd10InfoTooltip(): string {
    return `Il campo Diagnosi ICD10 e' obbligatorio per le strutture in sperimentazione per i soli contatti avviati a partire dal ${this.formatDiagnosiIcd10RequiredDate()}. E' facoltativo per le altre strutture.`;
  }

  getDiagnosiIcd9InfoTooltip(): string {
    return "Valorizzando il campo Diagnosi ICD10 e cliccando nel campo Diagnosi ICD9 sara' possibile visionare una lista delle Diagnosi ICD9, corrispondenti al codice ICD10 inserito, suggerite dal Ministero della Salute. E' possibile selezionare una voce dal menu proposto oppure digitare una Diagnosi ICD9 alternativa, purche' tra le diagnosi ammissibili ICD9 previste da SISTeP.";
  }

  /**
   * //[CHANGE-REQUEST][PRE-RILASCIO]
   * Format della data di obbligatorieta' ICD10 per la visualizzazione nella notina informativa.
   * @lastUpdate 2026-03-11 - Alessio Scoppetta
   * @author Alessio Scoppetta
   */
  private formatDiagnosiIcd10RequiredDate(): string {
    const d = this.diagnosiIcd10RequiredFromDate;
    const day = `${d.getDate()}`.padStart(2, '0');
    const month = `${d.getMonth() + 1}`.padStart(2, '0');
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  }

  private refreshDiagnosiIcd10Validators(): void {
    const ctrl = this.diagnosiScaleForm?.get('diagnosiScalaICD10');
    if (!ctrl) return;

    if (!this.showDiagnosiIcd10()) {
      ctrl.clearValidators();
      ctrl.updateValueAndValidity({ onlySelf: true, emitEvent: false });
      return;
    }

    const validators = [optionalDiagnosiValidator()];
    if (this.isDiagnosiIcd10Required()) {
      validators.unshift(Validators.required);
    }
    ctrl.setValidators(validators);
    ctrl.updateValueAndValidity({ onlySelf: true, emitEvent: false });
  }

  private refreshIcd9SuggestionsFromIcd10(): void {
    if (!this.showDiagnosiIcd10()) {
      this.lastIcd10SuggestionsCode = null;
      this.suggestedDiagnosiIcd9 = [];
      return;
    }

    const model = this.diagnosiScaleForm?.get('diagnosiScalaICD10')?.value ?? this.modelDiagnosiIcd10;
    const resolved = this.resolveDiagnosiIcd10Model(model);
    const codiceIcd10 = resolved?.codice?.trim() ? resolved.codice.trim() : null;

    if (!codiceIcd10) {
      this.lastIcd10SuggestionsCode = null;
      this.suggestedDiagnosiIcd9 = [];
      return;
    }

    if (this.lastIcd10SuggestionsCode === codiceIcd10 && this.suggestedDiagnosiIcd9.length > 0) return;
    this.lastIcd10SuggestionsCode = codiceIcd10;

    this.apiService.getIcd9SuggestionsByIcd10(codiceIcd10).subscribe({
      next: (res) => {
        this.suggestedDiagnosiIcd9 = res ?? [];
      },
      error: () => {
        this.suggestedDiagnosiIcd9 = [];
      }
    })
  }

  private mergeDiagnosiIcd9Results(term: string): Diagnosi[] {
    const normalizedTerm = (term ?? '').toLowerCase();
    const suggestions = this.suggestedDiagnosiIcd9 ?? [];

    // se ICD10 selezionata e ci sono suggerimenti: al focus/click mostra i suggeriti anche con term corto
    if (this.showDiagnosiIcd10() && suggestions.length > 0) {
      if (!normalizedTerm || normalizedTerm.length < 2) {
        return suggestions;
      }
      const matches = this.listDiagnosi.filter(dia =>
        dia && dia.descrizione && dia.descrizione.toLowerCase().indexOf(normalizedTerm) > -1
        || dia && dia.codice && dia.codice.toLowerCase().indexOf(normalizedTerm) > -1
      );
      const matchCodes = new Set(matches.map(m => (m?.codice ?? '').toLowerCase()));
      const suggestedNotInMatches = suggestions.filter(s => !matchCodes.has((s?.codice ?? '').toLowerCase()));
      return matches.concat(suggestedNotInMatches);
    }

    if (!normalizedTerm || normalizedTerm.length < 2) return [];
    return this.listDiagnosi.filter(dia =>
      dia && dia.descrizione && dia.descrizione.toLowerCase().indexOf(normalizedTerm) > -1
      || dia && dia.codice && dia.codice.toLowerCase().indexOf(normalizedTerm) > -1
    );
  }

  private loadDiagnosiIcd10RequiredDate(): void {
    this.apiService.getDataDiagnosiIcd10Config().subscribe({
      next: (dateValue: string) => {
        const parsedDate = this.parseConfigDate(dateValue);
        if (parsedDate) {
          this.diagnosiIcd10RequiredFromDate = parsedDate;
          this.refreshDiagnosiIcd10Validators();
        }
      },
      error: () => {
        // Mantiene il fallback locale se la config non e' disponibile.
      }
    });
  }

  private parseConfigDate(dateValue: string | null | undefined): Date | null {
    const rawValue = (dateValue ?? '').toString().trim();
    if (!rawValue) return null;

    const parts = rawValue.split('-').map(Number);
    if (parts.length !== 3 || parts.some(Number.isNaN)) {
      return null;
    }

    return new Date(parts[0], parts[1] - 1, parts[2]);
  }

  loadDiagnosiIcd10List() {
    this.apiService.getAllDiagnosiIcd10().subscribe(res => {
      this.listDiagnosiIcd10 = res ?? [];
    })
  }

  getDiagnosiModel(contatto: Contatto, diagnosiScale: DiagnosiEScale, diagnosiList: Diagnosi[]): Diagnosi |null{

    const codice = (diagnosiScale?.diagnosi ?? '').toString().trim();
    if (codice) {
      // preferisco la descrizione già presente sulla riga (render immediato, anche se la lista non è ancora caricata)
      const fromRow = new Diagnosi();
      fromRow.codice = codice;
      (fromRow as any).descrizione = (diagnosiScale as any)?.descrizioneDiagnosi ?? '';
      // se ho la lista, provo anche a risolvere la descrizione "ufficiale"
      return this.filterDiagnosi(diagnosiScale, diagnosiList) ?? fromRow;
    }

    if (this.isFirstDiagnosiOfContatto(contatto.diagnosiEScaleList!!)) {
      return this.getDiagnosiModelFromContatto(contatto)
    }

    return null
  }

  filterDiagnosi(diagnosiScale: DiagnosiEScale, diagnosiList: Diagnosi[]): Diagnosi | null {
    const target = (diagnosiScale.diagnosi ?? '').toString().trim();
    if (!target) return null;
    const found = diagnosiList.find(diag => (diag?.codice ?? '').toString().trim() === target);
    return found ?? null;
  }

  isDiagnosiEScaleNotNew(diagnosiScale: DiagnosiEScale): boolean {

    return diagnosiScale.id != null && diagnosiScale.id != undefined
  }

  getDiagnosiModelFromContatto(contatto: Contatto): Diagnosi {


    let diagnosi = new Diagnosi()

    diagnosi.codice = contatto.codiceDiagnosiApertura!!
    diagnosi.descrizione = contatto.descrizioneDiagnosiApertura!!


    return diagnosi;
  }



  setFormValues(diagnosiScala: DiagnosiEScale) {

    this.diagnosiScaleForm.get('scalaHonos')!!.patchValue(diagnosiScala.scalaHonos)

    this.diagnosiScaleForm.get('scalaBprs')!!.patchValue(diagnosiScala.scalaBprs)

  }

  submitForm(values: any) {

    this.formSubmitted = true

    if (!this.hasWritePermission(this.mainUser)) {
      this.toastService.showError('Non hai i permessi per modificare e salvare Diagnosi & Scale.');
      return;
    }

    if (this.diagnosiScaleForm.valid) {

      let diagnosiScala: DiagnosiEScale = values

      diagnosiScala.id = this.diagnosiScala.id
      diagnosiScala.data = this.sessionService.toNativeDate(this.dateModel)!!
      diagnosiScala.contatto = this.contatto
      diagnosiScala.diagnosi = this.modelDiagnosi.codice
      diagnosiScala.descrizioneDiagnosi = this.modelDiagnosi.descrizione
      diagnosiScala.codiceAslOperatoreInserimento = this.contatto.codiceAslOperatoreInserimento
      const diagnosiIcd10 = this.resolveDiagnosiIcd10Model(this.diagnosiScaleForm.get('diagnosiScalaICD10')?.value ?? this.modelDiagnosiIcd10);
      if (diagnosiIcd10) {
        diagnosiScala.diagnosiIcd10 = diagnosiIcd10.codice
        this.modelDiagnosiIcd10 = diagnosiIcd10;
        this.diagnosiScaleForm.get('diagnosiScalaICD10')?.setValue(diagnosiIcd10, { emitEvent: false });
      } else {
        diagnosiScala.diagnosiIcd10 = undefined;
        this.modelDiagnosiIcd10 = null;
        this.diagnosiScaleForm.get('diagnosiScalaICD10')?.setValue(null, { emitEvent: false });
      }
      this.blockUI.start("Salvataggio in corso")

      let codiceStruttura = this.sessionService.getSelectedStrutturaFromStorage()?.codice

      this.apiService.saveDiagnosiEScala(diagnosiScala, codiceStruttura!!).subscribe({
        next: (res) => {
          let diagnosi: DiagnosiEScale = res
          this.sessionService.setSelectedDiagnosiScale(JSON.stringify(diagnosi!!))
          this.toastService.showSuccess('Salvataggio effettuato con successo');
          this.refreshData()
          this.back();
        },

        error: (err) => {

          console.log(err);

          // this.blockUI.stop()

          this.toastService.showError('Correggere gli errori di compilazione');

        },

        complete: () => {


          this.blockUI.stop()
        }
      })
    } else {
      this.toastService.showError("Correggere gli errori di compilazione")
    }
  }


  dateExistInDates(date: NgbDateStruct) {
    let exist = this.listDate.indexOf(JSON.stringify(date)) !== -1

    if (exist === true) {
      this.diagnosiScaleForm.get('data')?.setErrors({ dateExist: true })
    } else {
      this.diagnosiScaleForm.get('data')?.setErrors({ dateExist: null })
      this.diagnosiScaleForm.controls['data'].updateValueAndValidity({onlySelf:true, emitEvent:false})
    }
  }

  back() {
    this.sessionService.setOpenTabContatto("TabDiagnosiScale")
    this.router.navigate(['contatto'])
  }

  hasWritePermission(utente: Utente): boolean {
    if (!utente) return false;
    if (!utente.funzionalita?.includes(Funzionalita.ANAGRAFICHE_INSERIMENTO)) return false;
    return this.getRuolo(this.OPERATORE_STRUTTURA);
  }

  openGoBackDialog(content: any) {

    if (!this.diagnosiScaleForm.dirty) {

      this.back()

    } else {

      this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
        this.closeResult = `Closed with: ${result}`;

        if (this.closeResult === 'Closed with: Back click') {
          this.back()

        }
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;


      });
    }

  }

  getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  openCancellaDialog(cancella: any) {

    this.modalService.open(cancella, { ariaLabelledBy: 'modal-basic-title' }).result
      .then((result) => {
          this.closeResult = `Closed with: ${result}`;

      if (this.closeResult === 'Closed with: Back click') {
        this.back()
      }
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });


  }

  cancellaVisibile(): Boolean {

    if (this.diagnosiScala && this.diagnosiScala.id != null && this.salvaVisibile()) {
      if(this.isContattoClosedAndLastDiagnosi() ||this.isFirstDiagnosiOfListContatto()){
        return false;
      }
      return true
    } else {
      return false
    }

  }

  salvaVisibile() {

    return this.hasWritePermission(this.mainUser);
  }

  cancellaDiagnosiEScala(id: number) {

    this.modalService.dismissAll()
    if (!this.hasWritePermission(this.mainUser)) {
      this.toastService.showError('Non hai i permessi per cancellare Diagnosi & Scale.');
      return;
    }
    if(!this.canDeleteDiagnosiEScale()){
      this.toastService.showError('Non è popssibile eliminare la diagnosi, è la prima o l\'ultima del contatto chiuso. ');
      return;
    }
    this.blockUI.start("Cancellazione  in corso")
    this.apiService.cancellaDiagnosiEScala(id).subscribe({
      next: (res) => {
        console.log(res);
        this.toastService.showSuccess('Cancellazione effettuata con successo');

        this.refreshData()
        this.back()
      },
      error: (err) => {

        this.blockUI.stop()
        this.toastService.showError('Si è verificato un errore durante la cancellazione');
      },
      complete: () => {

        this.blockUI.stop()

      }
    })
  }

  async getAllDiagnosi() {


    return await firstValueFrom(this.apiService.getAllDiagnosi())

  }

  // campiPrimaDiagnosiReadonly(listDiagnosi: DiagnosiEScale[]) {
  //
  //   // if(this.isFirstDiagnosiOfContatto(listDiagnosi)){
  //     let  isFirst: boolean = false;
  //     const itsort = this.contatto.diagnosiEScaleList?this.contatto.diagnosiEScaleList.sort((a, b) => this.getTime(a.data)-this.getTime(b.data)):[];
  //     isFirst = (itsort.findIndex(value => value.id == this.diagnosiScala.id) == 0)||itsort.findIndex(value => value.id == this.diagnosiScala.id) == 0;
  //     console.log("ISFIRST: ", isFirst)
  //   console.log("list:", this.contatto.diagnosiEScaleList )
  //     return isFirst;
  campiPrimaDiagnosiReadonly(listDiagnosi: DiagnosiEScale[]) {
    let isFirst: boolean = false;

    const itsort = this.contatto.diagnosiEScaleList
      ? this.contatto.diagnosiEScaleList.sort((a, b) => this.getTime(a.data) - this.getTime(b.data))
      : [];

    // Se l'array è vuoto O se l'elemento corrente è il primo nell'array ordinato
    isFirst = itsort.length === 0 || itsort.findIndex(value => value.id == this.diagnosiScala.id) === 0;

    return isFirst;

    // } else {
      /*const minId = listDiagnosi
        .reduce((min, obj) => Math.min(min, obj!.id!), Infinity);
      return minId == this.diagnosiScala.id;*/
      //
    //   const itsort = this.contatto.diagnosiEScaleList?this.contatto.diagnosiEScaleList.sort((a, b) => this.getTime(a.data)-this.getTime(b.data)):[];
    //   const isLast = (itsort.findIndex(value => value.id == this.diagnosiScala.id) == itsort?.length! - 1)||itsort.findIndex(value => value.id == this.diagnosiScala.id) == 0;
    //   return isLast;
    // }

  }

  isFirstDiagnosiOfContatto(listDiagnosi: DiagnosiEScale[]) {

    if (listDiagnosi.length === 0) {
      return true
    } else {
      return false
    }

  }

  limitDateByContattoDate(contatto: Contatto) {

    let minDateModel = this.sessionService.convertToDateStruct(new Date(contatto.dataApertura!!))
    this.minDate = { year: minDateModel!!.year, month: minDateModel!!.month, day: minDateModel!!.day }
    if(contatto.dataChiusura){
      /**
       * //[CHANGE-REQUEST][PRE-RILASCIO]
       * In inserimento diagnosi la data massima selezionabile deve coincidere con la
       * data di chiusura del contatto, non con l'ultima diagnosi gia' registrata.
       * Le date gia' occupate restano comunque bloccate tramite disabledDates.
       * @lastUpdate 2026-03-11 - Alessio Scoppetta
       * @author Alessio Scoppetta
       */
      let maxDateModel = this.sessionService.convertToDateStruct(new Date(this.contatto.dataChiusura!!));
      this.maxDate = { year: maxDateModel!!.year, month: maxDateModel!!.month, day: maxDateModel!!.day }

    } else {

      let todayDate = this.sessionService.convertToDateStruct(new Date())
      this.maxDate = {year:todayDate?.year!!, month:todayDate?.month!!, day:todayDate?.day!!}

    }

  }

  limitDateByDiagnosiDate(diagnosi:DiagnosiEScale) {

    let minDateModel = this.sessionService.convertToDateStruct(new Date(diagnosi.data!!))
    this.minDate = { year: minDateModel!!.year, month: minDateModel!!.month, day: minDateModel!!.day}

  }

  refreshData(){

    this.sessionService.setRefreshdata(true)
  }

  observeStrutturaChange(){


    this.sessionService.strutturaChanged.subscribe(res => {

      if(res){
        this.router.navigate(['ricerca-anagrafica'])
      }
    })
  }

  limitMaxDate(){
    const itsort = this.contatto.diagnosiEScaleList?this.contatto.diagnosiEScaleList.sort((a, b) => /*a.id && b.id && a.id <= b.id ? -1 : 1*/this.getTime(a.data)-this.getTime(b.data)):[];

    let todayDate = this.sessionService.convertToDateStruct(!itsort||itsort.length<1?new Date():new Date(itsort![itsort?.length!-1].data!));

    //let todayDate = this.sessionService.convertToDateStruct(new Date())

    this.maxDate = {year:todayDate?.year!!, month:todayDate?.month!!, day:todayDate?.day!!}
  }

  // prova() {
  //   console.log( 'modelDiagnosi' + this.modelDiagnosi )
  //   console.log( 'value' + this.diagnosiScaleForm.get('diagnosiScala')?.value )
  //   console.log( new CommonsUtil().validFields(this.diagnosiScaleForm) )
  //   console.log( this.diagnosiScaleForm.valid )
  // }
  public OPERATORE_STRUTTURA: String = "operatore-struttura";
  public OPERATORE_ASL: String = "operatore-asl";
  public OPERATORE_DSM: String = "operatore-dsm";
  public OPERATORE_REGIONE: String = "operatore-regione";
  auditDiagnosiEScale: DiagnosiEscaleAudit[] = [];
  storicoTitle: any;
  public getRuolo(ruolo: String) {


    if (this.mainUser) {

      if (this.mainUser.nomeRuolo == ruolo) {

        return true;

      }

    }

    return false;

}


openAuditDialog(audit: any){

  this.storicoTitle = ""

  this.apiService.getIDiagnosiEscaleAuditByIdAndStruttura(this.diagnosiScala?.id!!, this.sessionService.getSelectedStrutturaFromStorage()?.codice!).subscribe(res => {
    if(res){

      this.auditDiagnosiEScale = res;

    }

  });
  this.modalService.open(audit, { ariaLabelledBy: 'modal-basic-title', size: 'xl', scrollable: true}).result.then((result) => {
    this.closeResult = `Closed with: ${result}`;

    if (this.closeResult === 'Closed with: Back click') {
      this.back()

    }
  }, (reason) => {
    this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;


  });
}

canDeleteDiagnosiEScale(): boolean{

  let maxDateObject = this.getLastDiagnosi();
  let minDateObject = this.getFirstDiagnosi();

  if(this.isFirstDiagnosi(minDateObject)){

    return false;

    }

  if(this.contatto.dataChiusura && this.isLastDiagnosi(maxDateObject)){

    return false

    }

  return true;

}

getFirstDiagnosi(): DiagnosiEScale{

  let minDateObject = this.contatto!.diagnosiEScaleList!.reduce((a, b) => new Date(a.data!).getTime() < new Date(b.data!).getTime() ? a : b);
  return minDateObject;

}

getLastDiagnosi() : DiagnosiEScale{

  let maxDateObject = this.contatto!.diagnosiEScaleList!.reduce((a, b) => new Date(a.data!).getTime() > new Date(b.data!).getTime() ? a : b);
  return maxDateObject;

}

isLastDiagnosi(lastDiagnosi: DiagnosiEScale): boolean{

  if(this.diagnosiScala.id == lastDiagnosi.id){

    return true;

  }

  return false;

}

isFirstDiagnosi(firstDiagnosi: DiagnosiEScale): boolean{

  if(this.diagnosiScala.id == firstDiagnosi.id){

    return true;

  }

  return false;
}

mustDisableForm(){

  if(this.diagnosiScala.statoAttuale && this.diagnosiScala.statoAttuale.id && this.diagnosiScala.statoAttuale.id >= 0 ){

    return this.enableStatiAttuali.indexOf(this.diagnosiScala.statoAttuale.id) == -1

  }

  return false;

}

  // Modificato MC 10/04/2025
  mustDisableCancelBtn() {
    if (this.diagnosiScala.statoAttuale.id >= 0) {
      let statiAttuali: Array<number> = [0, 1, 2, 4, 7, 9];
      return statiAttuali.indexOf(this.diagnosiScala.statoAttuale.id) == -1
    }
    return true;
  }

  private isFirstDiagnosiOfListContatto() {
    const itsort = this.contatto.diagnosiEScaleList?this.contatto.diagnosiEScaleList.sort((a, b) => a.id && b.id && a.id >= b.id ? -1 : 1):[];
    const isi = itsort.findIndex(value => value.id == this.diagnosiScala.id) == itsort?.length! - 1;
    if (isi) {
      return true;
    } else {
      return false;
    }
  }

  public  isContattoClosedAndLastDiagnosi() {
      const itsort = this.contatto.diagnosiEScaleList?this.contatto.diagnosiEScaleList.sort((a, b) => /*a.id && b.id && a.id <= b.id ? -1 : 1*/this.getTime(a.data)-this.getTime(b.data)):[];
      const isLast = itsort.findIndex(value => value.id == this.diagnosiScala.id) == itsort?.length! - 1;
      if (this.contatto.dataChiusura && isLast) {
        return true;
      } else {
        return false;
      }
    }

    /**
     * [CHANGE: ADEGUAMENTO-ICD10 ] Visibilità delle Info per ICD9 Solo in Modifica/Compilazione
     * @returns
     */
  canEditDiagnosiIcd9(): boolean {
    return this.hasWritePermission(this.mainUser)
      && !this.campiPrimaDiagnosiReadonly(this.contatto.diagnosiEScaleList!!)
      && !this.mustDisableForm()
      && !this.isContattoClosedAndLastDiagnosi();
  }

  private getTime(date?: Date) {
    return date != null ? new Date(date).getTime() : 0;
  }
  /**
   * //[CHANGE-REQUEST][PRE-RILASCIO]
   * Per la prima diagnosi del contatto usa come fallback il valore ICD10 gia'' presente
   * sul contatto, anche se la riga Diagnosi&Scale non e'' ancora stata registrata.
   * @lastUpdate 2026-03-11 - Alessio Scoppetta
   * @author Alessio Scoppetta
   */
  getDiagnosiIcd10Model(contatto: Contatto, diagnosiEScale: DiagnosiEScale): DiagnosiIcd10 | null {
    if (diagnosiEScale?.diagnosiIcd10 && diagnosiEScale.diagnosiIcd10.toString().trim() !== '') {
      return this.getDiagnosiIcd10ModelFromCode(diagnosiEScale.diagnosiIcd10);
    }

    if (this.isFirstDiagnosiOfContatto(contatto.diagnosiEScaleList!!)
      && contatto?.codiceDiagnosiAperturaIcd10
      && contatto.codiceDiagnosiAperturaIcd10.toString().trim() !== '') {
      return this.getDiagnosiIcd10ModelFromCode(contatto.codiceDiagnosiAperturaIcd10);
    }

    this.modelDiagnosiIcd10 = null
    return null;
  }

  getDiagnosiIcd10ModelFromDiagnosi(diagnosiEScale: DiagnosiEScale): DiagnosiIcd10 | null {
    if (!(diagnosiEScale?.diagnosiIcd10 && diagnosiEScale.diagnosiIcd10.toString().trim() !== '')) {
      this.modelDiagnosiIcd10 = null
      return null;
    }
    return this.getDiagnosiIcd10ModelFromCode(diagnosiEScale.diagnosiIcd10);
  }

  private getDiagnosiIcd10ModelFromCode(codiceIcd10: string): DiagnosiIcd10 | null {
    let diagnosi = new DiagnosiIcd10();

    if (codiceIcd10 && codiceIcd10.toString().trim() !== '') {
      diagnosi.codice = codiceIcd10
      diagnosi.descrizione = '' // placeholder finche arriva la risposta

      // chiamata asincrona: aggiorna descrizione quando arriva la risposta
      this.apiService.getDiagnosiIcd10ById(diagnosi.codice).subscribe({
        next: (res) => {
          diagnosi.descrizione = res?.descrizione ?? ''
          this.modelDiagnosiIcd10 = diagnosi
          this.diagnosiScaleForm.get('diagnosiScalaICD10')?.setValue(diagnosi, { emitEvent: false })
        },
        error: () => {
          diagnosi.descrizione = ''
          this.modelDiagnosiIcd10 = diagnosi
          this.diagnosiScaleForm.get('diagnosiScalaICD10')?.setValue(diagnosi, { emitEvent: false })
        }
      })
    } else {
      this.modelDiagnosiIcd10 = null
      return null;
    }
    return diagnosi;
  }

  getDiagnosiIcd10NameByCodice(codice: string) {
    // se ancora vuoi un helper basato su Observable
    return this.apiService.getDiagnosiIcd10ById(codice).pipe(
      map(res => res?.descrizione ?? '')
    );
  }

}

